module.exports = __webpack_public_path__ + "img/bg_map.5bfb8fa5.png";